// 9fbef606107a605d69c0edbcd8029e5d

export const lblCompleteTheLook = 'lbl_complete_the_look';

export const pdpSubLabels = {
  ProductDetailPage: {
    PDP_Sub: {
      [lblCompleteTheLook]: 'Complete The Look',
    },
  },
};
